module.exports = __webpack_public_path__ + "static/media/06-Stuttgart.17b6383d.jpg";